export default __webpack_public_path__ + "static/char-v-50-zh-Hant-c951749bad00d33e53d526e7c9ba48f4.mp4";